const pointExists = (point, checkCoordinates) => {
  if (point) {
    return checkCoordinates ? !!(point.latitude && point.longitude) : true
  }

  return false
}

const mergePoint = (
  point,
  options = { markerOptions: {}, defaultMarkerImage: null, label: null }
) => {
  const _point = point || pointTemplate
  return {
    ..._point,
    label: options.label,
    point: {
      lat: _point.latitude,
      lng: _point.longitude
    },
    markerAttrs: {
      width: (options.markerOptions && options.markerOptions.width) || 35,
      height: (options.markerOptions && options.markerOptions.height) || 40,
      image:
        (options.markerOptions && options.markerOptions.image) ||
        options.defaultMarkerImage
    }
  }
}

export default {
  account: (state) => state.$account,
  permissions: (state) => state.$permissions,
  fingerprint: (state) => state.fingerprint,
  webView: (state) => state.webView,
  mapOptions: (state) => state.mapOptions,
  appVersion: (state) => state.appVersion,
  clientType: (state) => state.clientType,
  orderTypes: (state) => state.order.types,
  activeOrderType: (state) => {
    return state.order.properties.orderTypeId
      ? state.order.types.find(
          (type) => type.id === state.order.properties.orderTypeId
        )
      : null
  },
  activeOrderRangeId: (state) => state.order.properties.orderRangeId,
  selectedCompanyForOrder: (state) => state.order.properties.selectedCourier,
  origin: (state) => state.order.data.origin,
  destination: (state) => state.order.data.destination,
  selectedAddressesById: (state) => {
    const ids = []
    if (state.order.data.origin.addressId)
      ids.push(state.order.data.origin.addressId)
    if (state.order.data.destination.addressId)
      ids.push(state.order.data.destination.addressId)
    return ids
  },
  orderInfoByKey: (state) => (key) => state.order.data[key],
  staticList: (state) => (list) => state.order.staticLists[list],
  orderWithCar: (state) => state.order.properties.withCar,
  orderCars: (state) => state.order.data.car,
  orderPackageTypes: (state) => state.order.data.packageType,
  orderEmployees: (state) => state.order.data.employee,
  orderItems: (state) => state.order.data.item,
  fetchedList: (state) => (list) => state.order.fetchedLists[list],
  order: (state) => state.order.data,
  orderOffers: (state) => state.order.data.acceptedOffers,
  firebaseMessagingToken: (state) => state.firebaseMessagingToken,
  middlePoints: (state) => state.order.data.middlePoints,

  userObject: (state) => state.userObject,
  orderConfig: (state) => state.orderConfig,
  orderObject: (state) => state.orderObject,
  orderPoints:
    (state) =>
    (
      options = {
        markerOptions: {},
        labelOptions: {},
        checkCoordinates: true,
        initiateOriginDestination: false
      }
    ) => {
      const points = []

      if (
        (options.initiateOriginDestination && !options.checkCoordinates) ||
        pointExists(state.orderObject.origin, options.checkCoordinates)
      ) {
        points.push(
          mergePoint(state.orderObject.origin, {
            markerOptions: options.markersOption,
            defaultMarkerImage:
              (options.markerOptions && options.markerOptions.originImage) ||
              require('@/assets/image/map-markers/origin.svg'),
            label:
              (options.labelOptions && options.labelOptions.origin) ||
              'load.origin'
          })
        )
      }

      if (
        state.orderObject.destinations &&
        state.orderObject.destinations.length
      ) {
        const multiDestination = state.orderObject.destinations.length > 1

        state.orderObject.destinations.forEach((destination, index) => {
          if (pointExists(destination, options.checkCoordinates)) {
            points.push(
              mergePoint(destination, {
                markerOptions: options.markerOptions,
                defaultMarkerImage: multiDestination
                  ? require(`@/assets/image/map-markers/destination.svg`)
                  : (options.markerOptions &&
                      options.markerOptions.destinationImage) ||
                    require('@/assets/image/map-markers/destination.svg'),
                label: multiDestination
                  ? `load.destinations.${index + 1}`
                  : (options.labelOptions &&
                      options.labelOptions.destination) ||
                    'load.destination'
              })
            )
          }
        })
      }

      if (options.initiateOriginDestination && points.length === 1) {
        points.push(
          mergePoint(null, {
            markerOptions: options.markerOptions,
            defaultMarkerImage:
              (options.markerOptions &&
                options.markerOptions.destinationImage) ||
              require('@/assets/image/map-markers/destination.svg'),
            label:
              (options.labelOptions && options.labelOptions.destination) ||
              'load.destination'
          })
        )
      }

      return points
    }
}
